import type { DashboardNavColor, Settings } from "@/types/settings";
import type { ApalNavItemConfig } from "./nav";
import { apalNavItems } from "./nav";

/**
 * Dashboard Configuration
 *
 * Configuration for the dashboard layout, consumed by VerticalLayout.
 */
export interface DashboardConfig {
	navColor: DashboardNavColor;
	navItems: ApalNavItemConfig[];
}

export const dashboardConfig: DashboardConfig = {
	navColor: "blend_in",  // Default nav color
	navItems: apalNavItems,
};

/**
 * Default settings for the application
 * These are used when initializing the SettingsProvider.
 */
export const defaultSettings: Settings = {
	direction: "ltr",
	dashboardLayout: "vertical",
	dashboardNavColor: "blend_in",
};
